const errorKeys = {
  NotAllowedError: 'permissionDenied',
  PermissionDeniedError: 'permissionDenied',
  SecurityError: 'permissionDenied',
  NotReadableError: 'recordingDeviceBusy',
  TrackStartError: 'recordingDeviceBusy',
  OverconstrainedError: 'recordingSettingsUnavailable',
  ConstraintNotSatisfiedError: 'recordingSettingsUnavailable',
  NotSupportedError: 'recordingFormatUnsupported',
  AbortError: 'recordingInterrupted',
};

// Only known names leave this boundary. Browser/device messages can contain
// hardware details and are neither actionable copy nor safe diagnostic labels.
export function recordingErrorInfo(error, { kind = 'audio',
  secureContext = typeof window !== 'undefined' ? window.isSecureContext : undefined } = {}) {
  if (secureContext === false) return { key: 'recordingNeedsHttps', name: 'InsecureContext' };
  if (error?.message === 'MEDIA_RECORDING_UNSUPPORTED') {
    return { key: 'recordingBrowserUnsupported', name: 'UnsupportedEnvironment' };
  }
  const name = error?.name;
  if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
    return { key: kind === 'video' ? 'recordingVideoDeviceMissing' : 'recordingAudioDeviceMissing', name };
  }
  if (Object.prototype.hasOwnProperty.call(errorKeys, name)) return { key: errorKeys[name], name };
  return { key: 'recordingError', name: 'UnknownError' };
}
